<template>
  <div class="main-container">
    <tl-header type="h1">Summary</tl-header>
    <div class="margin-t-m">
      <div class="company-info">
        <div class="title">
          <img :src="logoUrl" class="Group-3" />
          <div class="org-header">
            <div>
              <div class="text-purple">{{ orgName }}</div>
              <div class="divider thin"></div>
            </div>
            <div class="org-address">
              <p v-if="orgAddress">{{ orgAddress }}</p>
            </div>
          </div>
        </div>

        <div class="org-desp">
          <div class="value">{{legalEntities.length}}</div>
          <div class="suffix">Legal Entities</div>
        </div>
      </div>
      <div class="business-info threeColumnGrid" v-show="legalEntities.length">
        <div class="org-header">
          <div class="text-purple">
            <span>{{businessUnits.length}}</span>
            <span class="suffix">&nbsp;&nbsp;Business Unit/s added</span>
          </div>
          <div class="divider thin"></div>
          <span class="sub-text" v-for="(unit, index) in businessUnits" :key="index">{{unit.name}}</span>
        </div>
        <div class="org-header">
          <div class="text-purple">
            <span>{{businessUnitTypes.length}}</span>
            <span class="suffix">&nbsp;&nbsp;Business Type/s added</span>
          </div>
          <div class="divider thin"></div>
          <span
            class="sub-text"
            v-for="(type, index) in businessUnitTypes"
            :key="index"
          >{{type.name}}</span>
        </div>
        <div class="view-btn">
          <btn
            text="View All"
            type="secondary"
            class="view-all-btn"
            @click="goToBusinessUnitsPage"
          />
        </div>
      </div>
      <!-- If entities present -->
      <div v-if="legalEntities.length">
        <div class="divider-grey"></div>
        <div class="text-purple entities">Complete your entities details</div>
        <div class="divider-grey"></div>
        <section class="singleRowGrid">
          <div v-for="(entity, index) in legalEntities" :key="index">
            <div class="entitycontainer">
              <div class="entity-detail">
                <label class="label">{{ entity.legalName }}</label>
              </div>
              <onboarding-progressbar class="progress-bar" value="35"></onboarding-progressbar>
              <!-- <div v-if="false">
              <btn class="entity-button" text="Proceed" type="primary" @click="routeToEntityDetail(index, entity)" />
              </div>-->
              <btn
                class="entity-button"
                text="Proceed"
                type="secondary"
                @click="routeToEntityDetail(index, entity)"
              />
            </div>
            <div class="divider-grey"></div>
          </div>
        </section>
      </div>
      <!-- If no entities -->
      <div v-else>
        <div class="add-entity" @click="$router.push('/onboarding/legal_entities')">
          <img src="@/assets/legalEntity.svg" class="building" />
          <div class="add-entity-text">Add Legal Entities</div>
        </div>
        <!-- <bottom-action-container>
          <btn-grp>
            <btn text="Continue" type="primary" />
          </btn-grp>
        </bottom-action-container> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { eventBus } from "@/main";
import OnboardingProgressbar from "@/components/onboarding/OnboardingProgressbar.vue";
export default {
  name: "onboardSummary",
  components: {
    OnboardingProgressbar
  },
  computed: {
    ...mapState({
      // entities: state => state.onboard.legal_entities.data,
      // business_units: state => state.onboard.business_units.data.data,
      // business_types: state => state.onboard.butypes.data.data,
      orgData: state => state.onboard.organization.data[0],

      // currentLegalEntity: state => state.onboard.legal_entities.currentLegalEntity
    }),
    ...mapGetters({
      legalEntityList: "onboard/legal_entities/getLegalEntityList",
      organizationData: "onboard/organization/orgnizationData"
    }),

    getOrgInfo() {
      this.setData();
    }
  },
  data() {
    return {
      legalEntities: [],
      businessUnits: [],
      businessUnitTypes: [],
      logoUrl: "",
      orgName: "",
      orgAddress: ""
    };
  },
  activated() {
    if(this.orgData){
      this.setData();
      }
    if (this.$_.isEmpty(this.legalEntityList)) {
      this.getLegalEntities();
    } else {
      this.legalEntities = this.legalEntityList;
    }

    // if (this.$_.isEmpty(this.business_units)) {
    //   this.getBusinessUnits();
    // } else {
    //   this.businessUnits = this.business_units;
    // }
    //
    // if (this.$_.isEmpty(this.business_types)) {
    //   this.getBusinessTypes();
    // } else {
    //   this.businessUnitTypes = this.business_types;
    // }
  },
  mounted() {
    if (this.$_.isEmpty(this.orgName)) {
      //console.log('Summary.vue',this.orgData)
      this.getOrg(this.orgData ? this.orgData.id:'');
    }

    if (this.$_.isEmpty(this.entities)) {
      this.getLegalEntities();
    } else {
      this.legalEntities = this.legalEntityList;
    }

    // if (this.$_.isEmpty(this.business_units)) {
    //   this.getBusinessUnits();
    // } else {
    //   this.businessUnits = this.business_units;
    // }
    //
    // if (this.$_.isEmpty(this.business_types)) {
    //   this.getBusinessTypes();
    // } else {
    //   this.businessUnitTypes = this.business_types;
    // }
  },
  methods: {
    ...mapActions({
      getOrg: "onboard/organization/fetchAll",
      fetch_le: "onboard/legal_entities/fetchAll"
      // fetch_BU: "onboard/business_units/fetchAll",
      // fetch_BUT: "onboard/butypes/fetchAll"
    }),
    async getLegalEntities() {
      //console.log("summary",this.orgid);
      try {
        let res = await this.fetch_le(
          this.orgData ? this.orgData.id:''
        );
        if (res.data.status) {
          this.legalEntities = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    // async getBusinessUnits() {
    //   try {
    //     let res = await this.fetch_BU(
    //       this.orgData ? this.orgData.id:''
    //     );
    //     if (res.data.status) {
    //       this.businessUnits = res.data.payload.data;
    //     }
    //   } catch (error) {
    //     //console.log(error);
    //   }
    // },
    // async getBusinessTypes() {
    //   try {
    //     let res = await this.fetch_BUT(
    //       this.orgData ? this.orgData.id:''
    //     );
    //     if (res.data.status) {
    //       this.businessUnitTypes = res.data.payload.data;
    //     }
    //   } catch (error) {
    //     //console.log(error);
    //   }
    // },
    setData() {
      this.orgName = this.orgData.name;
      this.logoUrl = this.orgData.logoURL;
      let address = this.orgData.headOfficeAddress;
      if (address) {
        this.orgAddress =
          address.address1 +
          ", " +
          address.address2 +
          ", " +
          (this.orgData.City ? this.orgData.City.city_name + ", " : "") +
          // address.state_name +
          // " - " +
          address.pincode;
      }
    },
    routeToEntityDetail(index) {
      eventBus.$emit("goToLocations");
      this.$router.push({
        path: "/onboarding/entity/" + index + "/locations"
      });
    }
    // goToBusinessUnitsPage() {
    //   this.$router.push({
    //     path: "/onboarding/business_units"
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.progress-bar {
  margin-left: 50px;
  margin-right: 50px;
  flex: 2;
}
.entity-detail {
  flex: 1;
  flex-wrap: wrap;
  max-width: 240px;
  overflow-wrap: break-word;
}
.entity-button {
  flex: 1;
  margin-left: auto;
}
.org-desp {
  text-align: right;
  display: flex;
  color: $color-primary;
  padding: 0 20px 10px 0;
  justify-content: flex-end;
  .value {
    font-size: 22px;
    font-weight: bold;
    margin-right: 5px;
  }
  .suffix {
    font-size: 10px;
    margin-top: 10px;
  }
}
.label {
  font-size: $font-size-l1;
  color: #616363;
}
.description {
  font-size: $base-font-size;
  color: #616363;
  width: 120px;
}
.title {
  display: flex;
  height: auto;
  padding: 10px;
  &.column {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    *:nth-child(n) {
      margin-bottom: 10px;
    }
  }
}
.add-entity-button {
  color: $color-secondary;
  margin-left: 70px;
  box-shadow: none;
}
.Group-3 {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-right: 10px;
  /*object-fit: contain;*/
}
.entitycontainer {
  display: flex;
  margin: 12px 0 15px 10px;
}
.org-address {
  width: 301px;
  height: 36px;
  font-size: $font-size-base;
  color: #0f0f0f;
  margin: 0 0 0 10px;
}
.add-entity {
  width: 314px;
  cursor: pointer;
  height: 179px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.5);
  background-color: white;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .building {
    width: 56px;
    height: 58px;
    object-fit: contain;
  }
  &:hover {
    background-color: $color-primary;
  }
  .add-entity-text {
    margin: 0 auto;
    color: $color-secondary;
    font-weight: bold;
    font-size: $font-size-base;
  }
}
.text-purple {
  color: $color-primary;
  font-size: $font-size-l1;
  font-weight: bold;
  padding: 4px 0 0 12px;
  &.entities {
    margin-top: 35px;
    margin-bottom: 20px;
  }
  .suffix {
    font-weight: normal;
    font-size: $font-size-small;
  }
}
.business-info-header {
  color: $color-primary;
  font-size: $font-size-l1;
}
.divider {
  color: $color-secondary;
  border-bottom: 2px solid $color-secondary;
  width: 90%;
  &.thin {
    border-bottom: 1px solid $color-secondary;
    margin-left: 10px;
    margin-top: 5px;
  }
}
.divider-grey {
  border-bottom: 2px solid #edecec;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 20px;
}
.divider-grey-light {
  border-bottom: 2px solid #d8d8d8;
  width: 100%;
  margin-bottom: 10px;
}
.company-info {
  height: auto;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  &.entity {
    margin-right: 20px;
  }
}
.business-info {
  margin-top: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 10px;
}
.row-container {
  .value {
    margin-right: 0;
  }
}
.view-all-btn {
  right: 20px;
  bottom: 20px;
}
// .view-btn {
//   position: relative;
// }
.org-header {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .sub-text {
    font-size: 14px;
    color: #000000;
    margin-left: 10px;
  }
  *:nth-child(n) {
    margin-bottom: 5px;
  }
}
</style>
